
<h3 class="announce-details-title">Détails de votre Annonce : <b><i> {{announce.title}}</i></b></h3>

<div class="container">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <ul class="carousel-indicators">
          <li *ngFor="let image of announce.images; let i = index" data-target="#demo" [attr.data-slide-to]="i" [class.active]="i==0" >
          </li>
        </ul>

        <div class="carousel-inner">
          <div class="carousel-item" *ngFor="let image of announce.images; let i = index" [class.active]="i==0">
            <img src="{{imagesDirectoryPath}}{{ announce.id + '/'}}{{image.name}}" alt="" width="100%" height="400px">
          </div>
        </div>

        <a class="carousel-control-prev" href="#demo" data-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next">
          <span class="carousel-control-next-icon"></span>
        </a>
      </div>

    </div>
  </div>
</div>


<div class="container">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h4 class="float-left ball-type"><b> <i class="fa fa-circle" aria-hidden="true"></i> {{ announce.type }}</b></h4>
            </div>
            <div class="col-md-6">
              <h4 class="float-right"><b> <i class="fa fa-calendar-o" aria-hidden="true"></i> {{ announce.created_at }}</b></h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h5><i class="fa fa-map-marker" aria-hidden="true"></i>  {{ announce.city }}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 class="announce-price"> {{ announce.price }} DH</h4>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <span><i class="fa fa-puzzle-piece" aria-hidden="true"></i><b> {{ announce.pieces }} Pièces</b></span>
              <span><i class="fa fa-bed" aria-hidden="true"></i><b> {{ announce.rooms }} Chambres</b></span>
              <span><i class="fa fa-area-chart" aria-hidden="true"></i><b> {{ announce.surface }} Métres</b></span>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <h4><i class="fa fa-info-circle" aria-hidden="true"></i> À propos de cette <strong>{{announce.type}}</strong></h4>
            <div class="col-md-12">
              <p>{{announce.description}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
